// automatically generated by the FlatBuffers compiler, do not modify

import { ElevatorControlMessage } from "../control/elevator-control-message";
import { EscalatorControlMessage } from "../control/escalator-control-message";

export enum DeviceControlMessage {
	NONE = 0,
	ElevatorControlMessage = 1,
	EscalatorControlMessage = 2,
}

export function unionToDeviceControlMessage(
	type: DeviceControlMessage,
	accessor: (
		obj: ElevatorControlMessage | EscalatorControlMessage
	) => ElevatorControlMessage | EscalatorControlMessage | null
): ElevatorControlMessage | EscalatorControlMessage | null {
	switch (DeviceControlMessage[type]) {
		case "NONE":
			return null;
		case "ElevatorControlMessage":
			return accessor(new ElevatorControlMessage())! as ElevatorControlMessage;
		case "EscalatorControlMessage":
			return accessor(new EscalatorControlMessage())! as EscalatorControlMessage;
		default:
			return null;
	}
}

export function unionListToDeviceControlMessage(
	type: DeviceControlMessage,
	accessor: (
		index: number,
		obj: ElevatorControlMessage | EscalatorControlMessage
	) => ElevatorControlMessage | EscalatorControlMessage | null,
	index: number
): ElevatorControlMessage | EscalatorControlMessage | null {
	switch (DeviceControlMessage[type]) {
		case "NONE":
			return null;
		case "ElevatorControlMessage":
			return accessor(index, new ElevatorControlMessage())! as ElevatorControlMessage;
		case "EscalatorControlMessage":
			return accessor(index, new EscalatorControlMessage())! as EscalatorControlMessage;
		default:
			return null;
	}
}
